var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditLoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_7634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.1245 6.705C8.7315 7.5015 8.199 8.295 7.6545 9.0075C7.13741 9.67876 6.58514 10.3222 6 10.935C5.41486 10.3222 4.86259 9.67876 4.3455 9.0075C3.801 8.295 3.2685 7.5015 2.8755 6.705C2.478 5.90025 2.25 5.1465 2.25 4.5C2.25 3.50544 2.64509 2.55161 3.34835 1.84835C4.05161 1.14509 5.00544 0.75 6 0.75C6.99456 0.75 7.94839 1.14509 8.65165 1.84835C9.35491 2.55161 9.75 3.50544 9.75 4.5C9.75 5.1465 9.52125 5.90025 9.1245 6.705ZM6 12C6 12 10.5 7.7355 10.5 4.5C10.5 3.30653 10.0259 2.16193 9.18198 1.31802C8.33807 0.474106 7.19347 0 6 0C4.80653 0 3.66193 0.474106 2.81802 1.31802C1.97411 2.16193 1.5 3.30653 1.5 4.5C1.5 7.7355 6 12 6 12Z",
    fill: "#545765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6C5.60218 6 5.22064 5.84196 4.93934 5.56066C4.65804 5.27936 4.5 4.89782 4.5 4.5C4.5 4.10218 4.65804 3.72064 4.93934 3.43934C5.22064 3.15804 5.60218 3 6 3C6.39782 3 6.77936 3.15804 7.06066 3.43934C7.34196 3.72064 7.5 4.10218 7.5 4.5C7.5 4.89782 7.34196 5.27936 7.06066 5.56066C6.77936 5.84196 6.39782 6 6 6ZM6 6.75C6.59674 6.75 7.16903 6.51295 7.59099 6.09099C8.01295 5.66903 8.25 5.09674 8.25 4.5C8.25 3.90326 8.01295 3.33097 7.59099 2.90901C7.16903 2.48705 6.59674 2.25 6 2.25C5.40326 2.25 4.83097 2.48705 4.40901 2.90901C3.98705 3.33097 3.75 3.90326 3.75 4.5C3.75 5.09674 3.98705 5.66903 4.40901 6.09099C4.83097 6.51295 5.40326 6.75 6 6.75Z",
    fill: "#545765"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_7634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditLoc);
export default __webpack_public_path__ + "static/media/credit-loc.06a028b63f6a2013b49f886decef82cd.svg";
export { ForwardRef as ReactComponent };